import { TabType } from '@wildberries/ui-kit';
import {
  SUPPLIES_ALL_TABS,
  SUPPLIES_TAB,
} from '@/pages/supplies-management/_layout/main-layout/_utils/_constants';

export const getTabs = (isQrSuppliesShown: boolean): Array<TabType> => {
  return isQrSuppliesShown ? SUPPLIES_TAB : SUPPLIES_ALL_TABS;
};
